/**
 * @param {*} string Input string.
 * @returns {any}
 */
export function stringToObject(string: string) {
  let newString = string;
  if (string.includes('ID3')) {
    newString = string
      // eslint-disable-next-line no-control-regex
      .replace(/[\r\n\x0B\x0C\u0085\u2028\u2029\u0002\u0003\u0004\u0005]+/g, '')
      .replace('ID3', 'ID3=')
      .replace('YMID', ',YMID=')
      .replace('YCSP', ',YCSP=')
      .replace('YSEQ', ',YSEQ=')
      .replace('YTYP', ',YTYP=')
      .replace('YDUR', ',YDUR=');
  }
  const array = newString.split(',');
  const obj: Record<string, any> = {};

  array.forEach(entity => {
    const tup = entity.split('=');
    // eslint-disable-next-line prefer-destructuring
    obj[tup[0]] = tup[1];
  });

  return obj;
}
